<template>
	<div class="box-description">
		<div class="row">

			<div class="col-12 col-service-title">
				<h5>Paquetes de Casa con SkyCel</h5>
			</div>

			<offers-slider class="col-12 col-carousel" ofertaTipo="planCasa" />

		</div>
	</div>
</template>

<script>
import offersSlider from '../../daniel/offers-slider.vue';
export default {
  components: { offersSlider },
};
</script>


